import { Component, OnInit, ViewChild, TemplateRef, Inject, ViewEncapsulation } from '@angular/core';
import { ParcelaService, DominiosService, GuiaPostalService, LoteFaturaService, EscritoriosService, DevedoresService } from '../shared/services/acordo-ressarcimento/api/services';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { LoadingService } from '../shared/services/components/loading.service';
import { AppComponent } from '../app.component';
import { Paginacao, Parcela, ParcelaPaginado, Devedor, TipoPessoaEnum, TipoLinhaTelefonicaEnum, LoteFatura, SituacaoLote, Telefone, EmailType, Endereco } from '../shared/services/acordo-ressarcimento/api/models';
import { PsModalLoadingComponent } from 'porto-seguro-guide';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { CnpjUtils } from '../shared/utils/cnpj.utils';

@Component({
  selector: 'app-repassar-valores-acordo',
  templateUrl: './repassar-valores-acordo.component.html',
  styleUrls: ['./repassar-valores-acordo.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class RepassarValoresAcordoComponent implements OnInit {
  public parcelaPaginado: ParcelaPaginado;
  public formPesquisa: FormGroup;
  public loadingLista = false;
  public selected = '';
  public page: Paginacao;
  public dadosParcela: Parcela[];
  public valorARepassarSelecionado: number = 0;
  public qtdARepassarSelecionado: number = 0;
  public parcelasSelecionadas: number[];
  source = [];
  columnsTemplate = [];
  public lote: LoteFatura = {};
  public statusLote: SituacaoLote;
  public devedor: Devedor = {};
  public isValido: boolean;

  @ViewChild('templateVencimento') private templateVencimento: TemplateRef<any>;
  @ViewChild('templateValor') private templateValor: TemplateRef<any>;
  @ViewChild('templateSelecao') private templateSelecao: TemplateRef<any>;
  @ViewChild('ModalConcluidoLote') modalConcluidoLote: PsModalLoadingComponent;

  constructor(
    private formBuilder: FormBuilder,
    public parcelaService: ParcelaService,
    public loteFaturaService: LoteFaturaService,
    public escritorioService: EscritoriosService,
    private loading: LoadingService,
    public dominiosService: DominiosService,
    public guiaPostalService: GuiaPostalService,
    private router: Router,
    @Inject(AppComponent) public appComponent: AppComponent) { }

  public ngOnInit() {
    this.columnsTemplate = [
      { prop: 'acordo.processoRessarcimento.codigoRamoSinistro', label: 'Ramo' },
      { prop: 'acordo.processoRessarcimento.numeroSinistro', label: 'Sinistro' },
      { prop: 'acordo.processoRessarcimento.anoSinistro', label: 'Ano' },
      { prop: 'acordo.codigoAcordo', label: 'Acordo' },
      { prop: 'numeroParcela', label: 'N° parcela' },
      { label: 'Data de vencimento', template: this.templateVencimento },
      { prop: 'tipoSituacaoParcelaAcordo.nomeTipoSituacaoParcelaAcordo', label: 'Status' },
      { label: 'Valor da parcela', template: this.templateValor },
      { label: 'Selecionar', template: this.templateSelecao },
    ];

    this.parcelaPaginado = undefined;
    this.criarFormPesquisa();
    this.verificaPagadorAlternativo();
  }

  private criarFormPesquisa() {
    this.formPesquisa = this.formBuilder.group({
      ramoSinistro: 746,
      anoSinistro: null,
      numeroSinistro: null,
      dataDe: null,
      dataAte: null,
    });
  }

  public log(event) {
    console.log(event);
  }

  public pesquisarParcelas(page) {
    this.loading.open();
    this.parcelaPaginado = undefined;

    if (page == undefined) {
      this.qtdARepassarSelecionado = 0;
      this.valorARepassarSelecionado = 0;
      this.parcelasSelecionadas = [];
      this.dadosParcela = [];
    }

    var parametros: ParcelaService.ObterParcelasLoteFaturaParams = {
      ramoSinistro: this.formPesquisa.value['ramoSinistro'],
      anoSinistro: this.formPesquisa.value['anoSinistro'],
      numeroSinistro: this.formPesquisa.value['numeroSinistro'],
      periodoInicial: this.formPesquisa.value['dataDe'],
      periodoFinal: this.formPesquisa.value['dataAte'],
      codigoEscritorio: this.formPesquisa.value['codigoEscritorio'],
      page: page == undefined ? 0 : page,
      perPage: 10,
    };

    this.parcelaService.obterParcelasLoteFatura(parametros).subscribe(response => {
      this.loading.close();
      this.parcelaPaginado = response;
      this.page = this.parcelaPaginado.paginacao;
      this.loadingLista = false;
      this.source = this.parcelaPaginado.parcelas;
    }, error => {
      this.loading.close();
      const theError: string = error.error.mensagens[2].mensagem;
      this.loadingLista = false;
      this.appComponent.createAlert("Erro ao efetivar consulta!", 'error');
      console.log('Erro ao criar a proposta!' + error);
    });
  }

  public gerarRelatorioParcela() {

    this.loading.open();

    this.parcelaService.obterRelatorioParcela(this.dadosParcela).subscribe(response => {
      if (response) {
        const blob = new Blob([response], { type: 'application/vnd.ms-excel' });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
        this.appComponent.createAlert('Relatório emitido com sucesso.', 'success');
      }
      this.loading.close();
    }, error => {
      this.loading.close();
      this.loadingLista = false;
      this.appComponent.createAlert('Não foi possível gerar o relatório.', 'error');
    });
  }

  public verificaPagadorAlternativo() {

    //codigo escritório fixo 2867 e 57 para teste, mudar depois
    var parametros: EscritoriosService.ObterEscritorioPagadorParams = {
      codigoEscritorio: 2867,
      codigoRamoSinistro: 57
    };

    this.escritorioService.obterEscritorioPagador(parametros).subscribe(result => {
      this.isValido = true;
      if (result != null) {

        //usando dados fixos 2867, substituir pelo codigo da pessoa logada
        this.devedor.codigoPessoa = result.codigoPessoa;
        this.devedor.codigoEscritorio = 2867;
        this.devedor.codigoOrigemSistema = 57;

        if (result.nome == null) {
          this.isValido = false
        } else {
          this.devedor.nome = result.nome
        }

        if (result.tipoPessoa == null) {
          this.isValido = false
        } else {
          this.devedor.tipoPessoa = result.tipoPessoa
        }

        if (result.cpf != null || result.cnpj != null) {
          if (result.cnpj != null) {
            this.devedor.cnpj = CnpjUtils.normalizar(result.cnpj);
          } else {
            this.devedor.cpf = CnpjUtils.normalizar(result.cpf);
          }
        } else {
          this.isValido = false
        }

        if (result.strCpfGrid == null || result.strCpfGrid.length != 11 && result.strCpfGrid.length != 14) { this.isValido = false }

        //verifica informações de endereço
        if (result.endereco.cep == null || result.endereco.cep.length < 9) { this.isValido = false }
        if (result.endereco.tipoEndereco == null) { this.isValido = false }
        if (result.endereco.logradouro == null) { this.isValido = false }
        if (result.endereco.numero == null) { this.isValido = false }
        if (result.endereco.bairro == null) { this.isValido = false }
        if (result.endereco.cidade == null) { this.isValido = false }
        if (result.endereco.estado == null) { this.isValido = false }

        //verifica emails
        if (result.emails.length == 0) {
          this.isValido = false
        } else {
          for (var i = 0; i < result.emails.length; i++) {
            if (result.emails[i].endereco == null) {
              this.isValido = false;
              break;
            }
          }
        }

        //verifica telefones
        if (result.telefones.length == 0) {
          this.isValido = false
        } else {
          for (var i = 0; i < result.telefones.length; i++) {
            if (result.telefones[i].codigoDDDTelefone == null) {
              this.isValido = false;
              break;
            }
            if (result.telefones[i].numeroTelefone == null) {
              this.isValido = false;
              break;
            }
            if (result.telefones[i].tipoLinhaTelefonica == null) {
              this.isValido = false;
              break;
            }
          }
        }
      } else {
        this.isValido = false;
      }
    });
  }

  public gerarLote(componenteModalGravando, componenteModalPadrao) {
    componenteModalPadrao.close();
    componenteModalGravando.open("save");
    console.log("isValido do gerarLote() " + this.isValido)

    if (this.isValido == false) {
      this.appComponent.createAlert('Por Favor! Verifique o cadastro do pagador alternativo em VALORES => DADOS DO PAGADOR', 'alert');
    } else if (this.parcelasSelecionadas.length == 0) {
      this.appComponent.createAlert('Sua lista de parcelas está vazia', 'alert');
    } else {
      console.log('Gerando lote');

      this.lote.codigoOrigemSistema = this.devedor.codigoOrigemSistema;
      this.lote.parcelaLista = {};
      this.lote.parcelaLista.parcelas = this.dadosParcela;
      this.lote.codigoPessoa = this.devedor;
      this.lote.valorTotalLote = this.valorARepassarSelecionado;

      this.loteFaturaService.salvarLoteFatura(this.lote).subscribe(response => {
        this.lote.numeroLote = response.codigoLote;
        componenteModalGravando.close();
        this.modalConcluidoLote.open(null);
      }, error => {
        const theError: string = error.error.mensagens[2].mensagem;
        componenteModalGravando.close();
        this.appComponent.createAlert('Não foi possível gerar o lote.', 'error');
      });
    }
  }

  public modalConcluidoLoteClick() {
    setTimeout(() => {
      this.router.navigate(['/detalhe-lote-fatura/' + this.lote.numeroLote]);
    }, 500);
  }

  public paginar(evt) {
    this.pesquisarParcelas(evt.offset);
  }

  public limparPesquisa() {
    this.ngOnInit();
  }

  public changeParcelaSelecionada(event, codigoParcela: number): void {
    var parcela = this.parcelaPaginado.parcelas.find(function (p) { return p.codigoParcela == codigoParcela });

    var target = event.target;
    if (target.checked) {
      this.parcelasSelecionadas.push(codigoParcela);
      this.dadosParcela.push(parcela);
      this.valorARepassarSelecionado = this.valorARepassarSelecionado + parcela.valorParcela;
      this.qtdARepassarSelecionado = this.qtdARepassarSelecionado + 1;
    } else {
      var index = this.parcelasSelecionadas.indexOf(codigoParcela);
      if (index > -1) {
        this.parcelasSelecionadas.splice(index, 1);
        this.dadosParcela.splice(this.dadosParcela.indexOf(parcela), 1);
        this.valorARepassarSelecionado = this.valorARepassarSelecionado - parcela.valorParcela;
        this.qtdARepassarSelecionado = this.qtdARepassarSelecionado - 1;
      }
    }
  }

  public isParcelaSelecionada(codigoParcela: number): boolean {
    return this.parcelasSelecionadas.indexOf(codigoParcela) != -1;
  }
}
